// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.debug-window {
    position: fixed;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    background-color: rgba(0, 0, 0, 0.8);
    color: #00ff00;
    padding: 10px;
    border-radius: 0 0 10px 10px;
    font-family: monospace;
    font-size: 12px;
    z-index: 9999;
    display: flex;
    gap: 20px;
    pointer-events: none;
    /* Let clicks pass through */
}

.debug-window div {
    white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/DebugWindow.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,SAAS;IACT,2BAA2B;IAC3B,oCAAoC;IACpC,cAAc;IACd,aAAa;IACb,4BAA4B;IAC5B,sBAAsB;IACtB,eAAe;IACf,aAAa;IACb,aAAa;IACb,SAAS;IACT,oBAAoB;IACpB,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".debug-window {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    background-color: rgba(0, 0, 0, 0.8);\r\n    color: #00ff00;\r\n    padding: 10px;\r\n    border-radius: 0 0 10px 10px;\r\n    font-family: monospace;\r\n    font-size: 12px;\r\n    z-index: 9999;\r\n    display: flex;\r\n    gap: 20px;\r\n    pointer-events: none;\r\n    /* Let clicks pass through */\r\n}\r\n\r\n.debug-window div {\r\n    white-space: nowrap;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
